import { getError, getValue } from 'mobx-async'

import { TapeChartDataStatus } from './types'

// Derives the load status of a tracked async value (mobx-async promise) for the
// tapechart error banners: failed, successfully loaded, or still in flight.
export const getTapeChartDataStatus = (
  asyncValue: Parameters<typeof getValue>[0],
): TapeChartDataStatus => {
  if (getError(asyncValue)) return 'error'
  if (getValue(asyncValue) !== undefined) return 'loaded'
  return 'loading'
}
